var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { wrap: "", "px-0": "" } },
    [
      _c(
        "v-flex",
        {
          staticClass: "form-section",
          attrs: { "pl-4": "", xs12: "", md6: "" }
        },
        [
          _c(
            "v-flex",
            { attrs: { "mb-3": "", xs12: "" } },
            [
              _c("v-layout", { staticClass: "title--text-custom" }, [
                _c("div", { staticClass: "primary--text" }, [_vm._v("1")]),
                _vm._v(" "),
                _c("div", { staticClass: "secondary--text" }, [_vm._v(".")])
              ]),
              _vm._v(" "),
              _c("h1", { staticClass: "primary--text " }, [
                _vm._v(_vm._s(_vm.$t(_vm.lblSetting.amCharPbFirstSectionModal)))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { row: "" } },
            [
              _c(
                "v-flex",
                { attrs: { "pl-0": "", "pr-4": "", xs12: "" } },
                [
                  _vm.displayLevel
                    ? _c(
                        "base-control-label-vertical",
                        {
                          attrs: {
                            required: "",
                            label: _vm.lblSetting.amCharPbLevel
                          }
                        },
                        [
                          _c("v-select", {
                            attrs: {
                              items: _vm.levels,
                              "item-value": "value",
                              "item-text": "name",
                              required: "",
                              rules: _vm.dtRules.level,
                              disabled: !_vm.displayLevel,
                              solo: ""
                            },
                            model: {
                              value: _vm.level,
                              callback: function($$v) {
                                _vm.level = $$v
                              },
                              expression: "level"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.charPbisLinked && _vm.level === 2
                    ? _c(
                        "base-control-label-vertical",
                        {
                          attrs: {
                            required: "",
                            label: _vm.lblSetting.amCharPbParent
                          }
                        },
                        [
                          _c("v-select", {
                            attrs: {
                              items: _vm.parentCharPbs,
                              "item-value": "value",
                              "item-text": "name",
                              disabled: true,
                              solo: ""
                            },
                            model: {
                              value: _vm.parent,
                              callback: function($$v) {
                                _vm.parent = $$v
                              },
                              expression: "parent"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "base-control-label-vertical",
                    {
                      attrs: {
                        required: "",
                        label: _vm.lblSetting.amCharPbName
                      }
                    },
                    [
                      _c("v-text-field", {
                        attrs: {
                          counter: 80,
                          maxlength: 80,
                          required: "",
                          rules: _vm.dtRules.name,
                          solo: ""
                        },
                        model: {
                          value: _vm.name,
                          callback: function($$v) {
                            _vm.name = $$v
                          },
                          expression: "name"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.editCharPbCode
                    ? _c(
                        "base-control-label-vertical",
                        {
                          attrs: {
                            required: _vm.charPbCodeRequired,
                            label: _vm.lblSetting.amCharPbCode
                          }
                        },
                        [
                          _c("v-text-field", {
                            attrs: {
                              counter: 10,
                              maxlength: 10,
                              solo: "",
                              required: _vm.charPbCodeRequired
                            },
                            model: {
                              value: _vm.code,
                              callback: function($$v) {
                                _vm.code = $$v
                              },
                              expression: "code"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        {
          staticClass: "form-section",
          attrs: { "pl-4": "", xs12: "", md6: "" }
        },
        [
          _c(
            "v-flex",
            { attrs: { "mb-3": "", xs12: "" } },
            [
              _c("v-layout", { staticClass: "title--text-custom" }, [
                _c("div", { staticClass: "primary--text" }, [_vm._v("2")]),
                _vm._v(" "),
                _c("div", { staticClass: "secondary--text" }, [_vm._v(".")])
              ]),
              _vm._v(" "),
              _c("h1", { staticClass: "primary--text " }, [
                _vm._v(
                  _vm._s(_vm.$t(_vm.lblSetting.amCharPbSecondSectionModal))
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "base-control-label-vertical",
            {
              staticClass: "mb-3",
              attrs: {
                label: _vm.picto
                  ? _vm.lblSetting.amCharPbIconUp
                  : _vm.lblSetting.amCharPbIcon
              }
            },
            [
              _c(
                "v-avatar",
                {
                  staticClass: "add-attachment-avatar mousechange",
                  attrs: { color: _vm.picto ? "primary" : "white" },
                  on: {
                    click: _vm.handleEditPicto,
                    mouseover: _vm.handlePictoMouseOver,
                    mouseleave: _vm.handlePictoMouseLeave
                  }
                },
                [
                  _vm.picto
                    ? _c("img", {
                        staticClass: "pa-1",
                        attrs: { src: _vm.picto }
                      })
                    : _c("v-icon", { attrs: { large: "", color: "primary" } }, [
                        _vm._v("add")
                      ]),
                  _vm._v(" "),
                  _vm.loadUpdatePicto
                    ? _c("v-progress-circular", {
                        staticStyle: { position: "absolute" },
                        attrs: { indeterminate: "", color: "primary" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hoverPicto && _vm.picto
                    ? _c(
                        "div",
                        {
                          staticClass: "white",
                          staticStyle: {
                            position: "absolute",
                            opacity: ".7",
                            width: "100%",
                            height: "60px"
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              attrs: {
                                large: "",
                                alt: "edit picture",
                                color: "primary"
                              }
                            },
                            [_vm._v("edit")]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("input", {
                ref: "file",
                staticStyle: { display: "none" },
                attrs: {
                  type: "file",
                  id: "file",
                  accept: "image/png, image/jpeg"
                },
                on: {
                  change: function($event) {
                    _vm.handleFileUpload($event.target)
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17c4e650", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17c4e650","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/profile/components/am-char-problem-modal-vertical/template.html
// module id = null
// module chunks = 